import Dexie from 'dexie';

const db = new Dexie('CollabCourseDB');

db.version(1).stores({
  progress: 'userId, progress',
});

export default db;
